// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconNotebook } from '@ni/nimble-components/dist/esm/icons/notebook';
import { wrap } from '../utilities/react-wrapper';

export { type IconNotebook };
export const NimbleIconNotebook = wrap(IconNotebook);